var site = site || {};
var addthisevent = addthisevent || {};

site.locator = site.locator || {};
site.locator.ui = site.locator.ui || {};
site.locator.data = site.locator.data || {};

site.locator.map = null; // Google map object
site.locator.mapDir = null; // Google map object
site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.resultData = {}; // contains results from doors query.
site.locator.resultData.results = []; // contains ordered results from doors query.
site.locator.infoWindow = null; // google.maps.InfoWindow object
site.locator.infoWindowDir = null; // google.maps.InfoWindow object
site.locator.queryFields =
  'DOOR_ID, DOORNAME, EVENT_NAME, EVENT_START_DATE, EVENT_END_DATE, EVENT_IMAGE, EVENT_FEATURES, EVENT_TIMES, SERVICES, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, REGION, COUNTRY, ZIP_OR_POSTAL, PHONE1, STORE_TYPE, LONGITUDE, LATITUDE';
site.locator.directionsDisplay = null; // google.maps.DirectionsRenderer object
site.locator.markerCounter = 0;
site.locator.travelMode = 'DRIVING';
site.locator.unitOfMeasure = 'mile'; // Unit of Measure
site.locator.appointmentBooking = false;

site.locator.defaultCountries = '';
site.locator.queryArgs = '';
site.locator.ui.initiated = false;

site.locator.locationData = site.locator.locationData || {};

site.locator.ui.getRBs = function () {
  var rb = generic.rb('language');

  site.locator.rb = {
    view_details: rb.get('view_details'),
    store: rb.get('store'),
    address: rb.get('address'),
    phone: rb.get('phone'),
    event_js: rb.get('event_js'),
    search_results: rb.get('search_results'),
    no_criteria: rb.get('no_criteria'),
    search_error: rb.get('search_error')
  };
};

site.locator.getDomNodes = function () {
  var $ = jQuery;
  var $wrapper = $('.store-locator');

  site.locator.nodes = {
    container: $wrapper,
    static_default_content_area: $('.store-locator__default'),
    results_area: $('.store-locator__main'),
    moreResultsContainer: $('.more-results-container', $wrapper),
    moreResultsButton: $('.more-results.button', $wrapper),
    countryMenu: $('select.country', $wrapper),
    localcountryMenu: $('select.local_country', $wrapper),
    cityMenuIntl: $('select.city_intl', $wrapper),
    stateMenu: $('div#store-search-controls select.state', $wrapper),
    cityMenu: $('select.js-city', $wrapper),
    doorMenu: $('select.door', $wrapper),
    doorRows: $('.door_row', $wrapper),
    doorWithEventRows: $('.door_row', $wrapper),
    doorWithoutEventRows: $('.door_row', $wrapper),
    searchInput: $('input.search', $wrapper),
    select_text: $('#locator-select', $wrapper),
    distanceMenu: $('select.distance', $wrapper),
    searchBtn: $('.search-submit', $wrapper),
    searchAltTxt: $('.search_alternative_text', $wrapper),
    searchBtnGeo: $('a.geo_search', $wrapper),
    searchBtnIntl: $('a#search_button_intl', $wrapper),
    searchPanel: $('fieldset#store-search-controls', $wrapper),
    landingPanel: $('div.locator_landing', $wrapper),
    mapPanel: $('div.locations_map_panel', $wrapper),
    map: $('div#map-canvas', $wrapper),
    storeResults: $('div#store_results', $wrapper),
    // eventResults     : $('div#event_results', $wrapper),
    locatorErrors: $('ul.locator_error_messages', $wrapper),
    locatorErrors_intl: $('ul.locator_error_messages_intl', $wrapper),
    dirErrors: $('div.directions-form__errors', $wrapper),
    dirAddrInput: $('div.directions_form input.address', $wrapper),
    dirCityInput: $('div.directions_form input.dirCity', $wrapper),
    dirStateMenuContainer: $('div.dir_state_container', $wrapper),
    dirStateMenu: $('div.directions_form select.dirState', $wrapper),
    dirCountryMenu: $('select.dirCountry', $wrapper),
    dirDoorInput: $('div.directions_form input.door', $wrapper),
    dirSubmit: $('.directions-form__submit', $wrapper),
    dirForm: $('form.directions-form', $wrapper),
    dirResults: $('.directions-form__results', $wrapper),
    dirPanel: $('div#locator_directions_panel', $wrapper),
    dirMap: $('div.directions_map_container', $wrapper),
    dirDestination: $('div.destination', $wrapper),
    dirFromAddr: $('input#from_address'),
    invalidZip: $('#locator-invalid-zip', $wrapper),
    missingCityUS: $('#locator-missing-city-us', $wrapper),
    missingCityIntl: $('#locator-missing-city-intl', $wrapper),
    missingStartAddr: $('#locator-missing-start-address', $wrapper),
    dirInvalidAddress: $('#locator-dir-invalid-address', $wrapper),
    dirNoRoute: $('#locator-dir-no-route', $wrapper),
    dirUnknownError: $('#locator-dir-unknown-error', $wrapper),
    localRegionIds: $('#region_ids', $wrapper),
    languageId: $('#language_id', $wrapper),
    intllocalRegionIds: $('#intl_region_ids', $wrapper),
    stateContainer: $('.state_container', $wrapper),
    localCountryContainer: $('.local_country_container', $wrapper),
    geocoderSearchText: $('#geocoder_search_text', $wrapper),
    geocoderSearchDefaultText: $('#geocoder_search_default_text', $wrapper),
    countryValue: $('#country_value', $wrapper),
    errors: {
      noSearchTerm: $('ul.error_messages li.no-search-term', $wrapper),
      noLocationsFound: $('ul.error_messages li.no-locations-found', $wrapper),
      noStoresFound: $('ul.error_messages li.no-stores-found', $wrapper),
      unrecognizedSearchTerm: $('ul.error_messages li.unrecognized-searchterm', $wrapper)
    }
  };

  // Remove the geolocation buttons when it's not available to the browser
  if (!navigator.geolocation || (generic.env.isFF && parseInt($.browser.version) <= 27)) {
    site.locator.nodes.searchBtnGeo.parent('.form_element').detach();
    site.locator.nodes.searchAltTxt.detach();
  }
};

site.locator.ui.getTemplates = function () {
  var temp = {};

  generic.template.get({
    path: '/templates/locator/location_info.tmpl',
    callback: function () {},
    object: temp
  });
  generic.template.get({
    path: '/templates/locator/doors_table.tmpl',
    callback: function () {},
    object: temp
  });
  generic.template.get({
    path: '/templates/locator/door_row.tmpl',
    callback: function () {},
    object: temp
  });
};

site.locator.ui.reset = function () {
  site.locator.nodes.dirAddrInput.val('');
};

/**
 * This function initializes the UI elements of the Store Locator page.
 * It communicates with site.locator.data via events.
 */
site.locator.ui.init = function () {
  var $ = jQuery;
  if (typeof site.locator.locationData === 'undefined') {
    return; // no location data!
  } else if ($.isEmptyObject(site.locator.locationData)) {
    $.getScript('/locator/store_data.tmpl').done(function () {
      if (!site.locator.ui.initiated) {
        site.locator.ui.initiated = true;
        site.locator.ui.init();
      }
    });

    return;
  }

  // set the default countries to the values passed by drupal
  site.locator.defaultCountries = $('#local_countries').val();

  // set the uom for directions to the values passed by drupal
  site.locator.unitOfMeasure = site.locator.nodes.distanceMenu.attr('data-distance-type') || 'mile';

  // set the appointment booking flag
  site.locator.appointmentBooking =
    $('.store-locator').attr('data-appointment-booking-enabled') == 1 ? true : false;

  /*
   * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
   */
  var _clearMenu = function (menu) {
    // menu[0].options.length = 0;
    // wipe out menu html
    menu.html('');

    // rebuild
    generic.forms.select.addOption({
      menuNode: menu,
      label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.select_text.text(),
      value: ''
    });
  };
  /*
   * Initializes select menus by adding default option and populating the State menu from JSON data in page
   */
  var _initMenus = function () {
    // insert default options

    $([
      site.locator.nodes.countryMenu,
      site.locator.nodes.localcountryMenu,
      site.locator.nodes.cityMenuIntl,
      site.locator.nodes.stateMenu,
      site.locator.nodes.cityMenu,
      site.locator.nodes.doorMenu
    ]).each(function () {
      _clearMenu($(this));
    });

    // Populate the country dropdown for the directions menu
    generic.forms.select.addOption({
      menuNode: site.locator.nodes.dirCountryMenu,
      value: site.locator.defaultCountries
    });

    //
    // populate local country select first if visible
    for (var country in site.locator.locationData) {
      if (country === '') {
        continue;
      }

      if (site.locator.defaultCountries.indexOf(country) !== -1) {
        if (
          site.locator.nodes.stateContainer.hasClass('neither') ||
          site.locator.nodes.cityMenu.length > 0
        ) {
          // only showing city filter...
          for (var state in site.locator.locationData[country]) {
            // if ( state == "" ) { continue; }
            for (var city in site.locator.locationData[country][state]) {
              generic.forms.select.addOption({
                menuNode: site.locator.nodes.cityMenu,
                value: city
              });
            }
          }
        } else if (!site.locator.nodes.localCountryContainer.hasClass('state')) {
          // showing local country filter...
          generic.forms.select.addOption({
            menuNode: site.locator.nodes.localcountryMenu,
            value: country
          });
        } else {
          // showing state
          for (var state in site.locator.locationData[country]) {
            if (state === '') {
              continue;
            }
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.stateMenu,
              value: state
            });
          }
        }
      } else {
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.countryMenu,
          value: country
        });
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.dirCountryMenu,
          value: country
        });
      }
    }

    site.locator.nodes.countryMenu.val(site.locator.nodes.countryMenu.data('country-selected'));

    site.locator.nodes.countryMenu.addClass('selectbox');

    site.locator.nodes.countryMenu.selectBox();
    site.locator.nodes.cityMenu.addClass('selectbox');
    site.locator.nodes.cityMenu.selectBox();
  };
  var _localcountryMenuChangeHandler = function (stateNode, cityNode) {
    _clearMenu(stateNode);
    _clearMenu(cityNode);

    // populate state drop-down if visible, otherwise populate city drop-down
    if (!site.locator.nodes.stateContainer.hasClass('country')) {
      for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
        if (state === '') {
          continue;
        }
        generic.forms.select.addOption({
          menuNode: stateNode,
          value: state
        });
      }
      stateNode.focus();
    } else {
      var cities = {};

      for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
        jQuery.extend(
          cities,
          site.locator.locationData[site.locator.nodes.localcountryMenu.val()][state]
        );
      }
      _filterCityMenu(cityNode, cities);
      _sortSelect(cityNode);
      cityNode.focus();
    }
    _refreshSelect(stateNode);
    _refreshSelect(cityNode);
  };
  var _countryMenuChangeHandler = function (cityNode) {
    var cities = {};

    for (var state in site.locator.locationData[site.locator.nodes.countryMenu.val()]) {
      jQuery.extend(cities, site.locator.locationData[site.locator.nodes.countryMenu.val()][state]);
    }
    _filterCityMenu(cityNode, cities);
    cityNode.focus();
  };
  /*
   * Event handler for onchange event on State menu
   */
  var _stateMenuChangeHandler = function (cityNode, locationData) {
    _filterCityMenu(cityNode, locationData[site.locator.nodes.stateMenu.val()]);
    cityNode.focus();
  };
  /*
   * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
   */
  var _filterCityMenu = function (cityNode, locationData) {
    _clearMenu(cityNode);
    // retrieve cities from that state, populate city menu
    var cityData = locationData;

    for (var city in cityData) {
      generic.forms.select.addOption({
        menuNode: cityNode,
        value: city
      });
    }
    _clearMenu(site.locator.nodes.doorMenu);
    _refreshSelect(cityNode);
  };
  /*
   * Sort select options in alphabetical order
   */
  var _sortSelect = function (selectNode) {
    var listitems = selectNode.children('option').get();

    listitems.sort(function (a, b) {
      return $(a).text().toUpperCase() === 'SELECT'
        ? -1
        : $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
    });
    $.each(listitems, function (idx, itm) {
      selectNode.append(itm);
    });
  };
  /*
   * Event handler for onchange event on City menu
   */
  var _cityMenuChangeHandler = function (doorNode, locationData) {
    var state = site.locator.nodes.stateMenu.val();
    var city = site.locator.nodes.cityMenu.val();

    // _filterDoorMenu( doorNode, locationData[state][city] );
    doorNode.focus();
  };
  /*
   * Reads value from city menu and populates door (store) menu with the appropriate values, based on JSON data in page
   */
  var _filterDoorMenu = function (doorNode, locationData) {
    _clearMenu(doorNode);
    var storeArray = locationData;

    for (var i = 0, len = storeArray.length; i < len; i++) {
      generic.forms.select.addOption({
        menuNode: doorNode,
        value: storeArray[i]
      });
    }
  };
  /*
   * Event handler for click of Doors search button
   */
  var _searchClickHandler = function () {
    var countryNameSubstitution = {};
    site.locator.ui.reset();
    var country =
      site.locator.nodes.countryValue.val() ||
      site.locator.nodes.countryMenu.val() ||
      site.locator.nodes.countryMenu.data('country-selected') ||
      '';
    var country_all = null;
    var search = site.locator.ui.getSearchVal();
    var distance = site.locator.nodes.distanceMenu.val();
    var searchTerm;
    // Setting the default country to US for one isn't selected.
    var isUS = site.locator.nodes.countryMenu.val().match(/^united states*/i)
      ? true
      : !country || country.length < 1;

    if (!country || !search) {
      site.locator.nodes.errors.noSearchTerm.removeClass('inactive');
      site.locator.nodes.errors.noLocationsFound.addClass('inactive');
      site.locator.nodes.countryMenu.addClass('required_field error');
      site.locator.nodes.searchInput.addClass('required_field error');

      return;
    } else {
      site.locator.nodes.countryMenu.addClass('required_field error');
      site.locator.nodes.searchInput.addClass('required_field error');
      site.locator.nodes.errors.noSearchTerm.addClass('inactive');
    }

    // Restrict address requirement to US searches only.
    //  If the user has attempted a "manual" search with no location/term, throw an error.
    if (isUS) {
      if (!search) {
        site.locator.nodes.errors.noSearchTerm.removeClass('inactive');
        site.locator.nodes.errors.noLocationsFound.addClass('inactive');
        $('input.search, select.country').addClass('required_field error');
        generic.focusErrors($('.js-locator_error_messages'), $('.js-store-locator-hero'));

        return;
      } else {
        $('input.search, select.country').removeClass('required_field error');
        site.locator.nodes.errors.noSearchTerm.addClass('inactive');
      }
      // Setting these manually.
      country = 'United States';
      if (!isNaN(distance) && distance < 30) {
        distance = 50;
      } // Must ensure a minimum radius of 50. This is temporary.
    }

    // get current content from main search text field, and run it through the geocoder
    // eslint-disable-next-line
    var geocoder = new google.maps.Geocoder();

    countryNameSubstitution = {
      'Hong Kong, SAR of China': 'HK',
      'Hong Kong, RAS de Chine': 'HK',
      'Macau, SAR of China': 'MO',
      'China Mainland': 'CN',
      'Chine Continentale': 'CN',
      'Taïwan, Chine': 'TW'
    };

    country = countryNameSubstitution[country] ? countryNameSubstitution[country] : country;

    if (search === site.locator.nodes.geocoderSearchText.val()) {
      search = site.locator.nodes.geocoderSearchDefaultText.val();
      searchTerm = { address: search };
    } else {
      searchTerm = {
        address: search,
        componentRestrictions: { country: country }
      };
    }
    geocoder.geocode(searchTerm, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        if (search) {
          filteredResults = site.locator.geocodeResultFilter(results);
        }

        // Handle country searches.
        if (!isUS) {
          if (!search) {
            filteredResults = results;
            country_all = country;
          }
        }

        if (filteredResults && filteredResults.length > 0) {
          _searchBaseHandler(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng(),
            distance,
            country_all
          );
          site.locator.addressDisplayData = results[0].formatted_address;
          site.locator.foundLocationData = results;
          site.locator.remainingLocationData = results.slice(1);
        } else {
          site.locator.nodes.errors.noLocationsFound.removeClass('inactive');
        }
      } else {
        site.locator.nodes.errors.unrecognizedSearchTerm.removeClass('inactive');
      }
      // ADA- Error focus
      generic.focusErrors($('.js-locator_error_messages'), $('.js-store-locator-hero'));
    });
  };
  var _searchGeoClickHandler = function () {
    site.locator.ui.reset();
    site.geo.locate(function (args) {
      var door = site.locator.nodes.doorMenu.val();
      var distance = site.locator.nodes.distanceMenu.val();
      var storeList = [];

      if (!!door) {
        if (door.length > 0) {
          storeList[0] = door;
          queryArgs.params[0].show_stores_list = storeList;
        }
      }

      // find the containing zip code, then send the query
      var geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(args.lat, args.lng);

      geocoder.geocode({ latLng: latlng }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          (function () {
            for (var i = 0; i < results.length; i += 1) {
              for (var j = results[i].address_components.length - 1; j >= 0; j -= 1) {
                if (
                  results[i].address_components[j].types.length === 1 &&
                  results[i].address_components[j].types[0] === 'postal_code'
                ) {
                  _searchBaseHandler(args.lat, args.lng);
                  site.locator.queryArgs.addressDisplayData =
                    results[i].address_components[j].long_name;

                  return;
                }
              }
            }
          })();
        } else {
          // set some sort of fail status
        }
      });
    });
  };
  /*
   * Collects parameters from form input elements, packs them into parameters,
   * then passes them to search query via the "locator:submitSearchQuery" event.
   * @see site.locator.data.submitQuery
   */
  var _searchBaseHandler = function (lat, lng, distance, country) {
    var queryArgs = {
      params: [
        {
          fields: site.locator.queryFields,
          radius: distance || site.locator.nodes.distanceMenu.val(),
          country: site.locator.nodes.countryValue.val() || site.locator.nodes.countryMenu.val(),
          region_id: site.locator.nodes.localRegionIds.val(),
          latitude: lat,
          longitude: lng,
          uom: site.locator.unitOfMeasure
        }
      ]
    };
    var currentCityVal =
      site.locator.nodes.cityMenu && site.locator.nodes.cityMenu.length > 0
        ? site.locator.nodes.cityMenu.val()
        : '';
    var passCityRpc = site.locator.nodes.container.hasClass('js-pass-city');

    if (site.locator.nodes.languageId.val()) {
      queryArgs.params[0].language_id = site.locator.nodes.languageId.val();
    }

    if (currentCityVal && passCityRpc) {
      queryArgs.params[0].city = currentCityVal;
    }

    queryArgs.callback = function () {
      site.locator.ui.displayMap();

      site.locator.ui.displayResultsTable();
    };

    $(document).trigger('locator.submitSearchQuery', [queryArgs]);

    site.locator.queryArgs = queryArgs;
  };
  var _refreshSelect = function ($selects) {
    // if implementing selectbox for custom dropdown
    /*
      $selects.each(function () {
        var $select = $(this);
        $select.selectbox("detach");
        $select.selectBox();
        $select.css("display", "none");
      });
      */
  };

  _initMenus();

  // prepopulate search field with form-submitted search value, if we're passed one, then submit
  var presubmittedSearch = generic.env.query('search');

  if (presubmittedSearch) {
    site.locator.nodes.searchInput.val(decodeURIComponent(presubmittedSearch).replace('+', ' '));
  }

  site.locator.nodes.countryMenu.bind('change', function (e) {
    _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
  });

  site.locator.nodes.searchBtn.bind('click', function (e) {
    _searchClickHandler();
  });

  site.locator.nodes.searchBtnGeo.bind('click', function (e) {
    _searchGeoClickHandler();
  });

  site.locator.nodes.searchInput.bind('keydown', function (e) {
    if (e.keyCode == 13) {
      _searchClickHandler();
    }
  });

  site.locator.ui.displayMap();

  // if we'd previously found a search term coming to us through the query string, and
  // have put it in our search field... trigger the click event, so that it's submitted
  if (presubmittedSearch) {
    site.locator.nodes.searchBtn.click();
  }

  // show status content, hide results/map
  site.locator.nodes.static_default_content_area.slideDown('slow');
  site.locator.nodes.results_area.slideUp('fast');
  $('.responsive-tabs--store-locator').easyResponsiveTabs();
  initDirectionsForm();
  initTravelMode();
  $('a.mobile-map').click(function (e) {
    e.preventDefault();
    $('a.mobile-map').addClass('active');
    $('a.mobile-list').removeClass('active');
    $('#map-canvas').show();
  });
  $('a.mobile-list').click(function (e) {
    e.preventDefault();
    $('a.mobile-map').removeClass('active');
    $('a.mobile-list').addClass('active');
    $('#map-canvas').hide();
  });
};

var initDirectionsForm = function () {
  var $ = jQuery;
  site.locator.nodes.dirSubmit.bind('click', function (evt) {
    evt.preventDefault();
    // Check if From Address is empty, show or hide error accordingly
    if (
      site.locator.nodes.dirFromAddr.val() === 'undefined' ||
      site.locator.nodes.dirFromAddr.val() === ''
    ) {
      // Get text from missingStartAddr error node and insert it into the error element
      site.locator.nodes.dirErrors.text(site.locator.nodes.missingStartAddr.text());

      return;
    } else {
      site.locator.nodes.dirErrors.text('');
    }
    var args = {
      startAddress: site.locator.nodes.dirAddrInput.val()
    };
    var doorId = site.locator.nodes.dirDoorInput.val();

    args.doorData = site.locator.resultData.results[doorId];
    $(document).trigger('locator.submitDirectionsQuery', [args]);
  });
};
var initTravelMode = function () {
  var $ = jQuery;
  $('.directions-form__transportation-mode-link[data-name]').click(function (e) {
    e.preventDefault();
    site.locator.travelMode = $(this).attr('data-name');
    site.locator.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
    $('.directions-form__transportation-mode-link[data-name]').removeClass('active');
    $(this).addClass('active');
    if ($('#to_address').val() !== '') {
      var args = {
        startAddress: site.locator.nodes.dirAddrInput.val()
      };
      var doorId = site.locator.nodes.dirDoorInput.val();

      args.doorData = site.locator.resultData.results[doorId];
      $(document).trigger('locator.submitDirectionsQuery', [args]);
    }
  });
};

/*
 * This function fetches the JS template: /templates/locator/location_info.tmpl
 * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
 */
site.locator.ui.buildLocationHtml = function (args) {
  var $ = jQuery;
  generic.template.get({
    path: '/templates/locator/location_info.tmpl',
    object: args.locationData,
    callback: function (html) {
      var $htm = $(html);

      if (site.locator.appointmentBooking) {
        var $apptBookLink = $htm.find('.store-locator__tooltip-book-appointment'),
          abHref = $apptBookLink.attr('href');

        if (args.locationData.APPT_BOOK_COUNTER_ID) {
          $apptBookLink.attr(
            'href',
            abHref + '?counter_id=' + args.locationData.APPT_BOOK_COUNTER_ID
          );
        } else {
          $apptBookLink.remove();
        }
      }
      args.callback($htm[0]);
    }
  });
};

site.locator.ui.directionsLink = function (row, doorData) {
  var $ = jQuery;
  $('a.js-directions-link', row).bind('click', function (evt) {
    evt.preventDefault();
    var daddr = [
      doorData.DOORNAME,
      doorData.ADDRESS,
      doorData.ADDRESS2,
      doorData.CITY,
      doorData.STATE_OR_PROVINCE,
      doorData.COUNTRY,
      doorData.ZIP_OR_POSTAL
    ];

    window.open('http://maps.google.com/maps?q=' + encodeURIComponent(daddr.join(', ')), '_blank');

    return false;
  });
};

/*
 * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayResultsTable = function () {
  var $ = jQuery;
  var tbody = null;
  var buildRow = function (doorData, idx) {
    doorData.index_number = idx;
    doorData.display_number = idx + 1;
    doorData.index_letter = site.locator.ui.getImageIndex(idx);
    doorData.distanceFormatted = parseFloat(doorData.DISTANCE).toFixed(2);
    doorData.distanceFormatted = isNaN(doorData.distanceFormatted)
      ? 'Unknown'
      : doorData.distanceFormatted;

    if (doorData.EVENT_START_DATE && doorData.EVENT_END_DATE) {
      var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
      var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));

      // PBruno: the check for the year has to  do with JS 1.2 backwards compatibility,
      // which would in some instances spit out a four-digit full year, for all
      // years not in 1900-1999; I just check for any four digit value for year,
      // and if I find one, leave it alone (forego adding the 1900)
      doorData.EVENT_DATE =
        event_start.getMonth() +
        1 +
        '/' +
        event_start.getDate() +
        '/' +
        (event_start.getYear() < 1000
          ? parseInt(event_start.getYear()) + 1900
          : event_start.getYear());
      doorData.EVENT_DATE += ' - ';
      doorData.EVENT_DATE +=
        event_end.getMonth() +
        1 +
        '/' +
        event_end.getDate() +
        '/' +
        (event_end.getYear() < 1000 ? parseInt(event_end.getYear()) + 1900 : event_end.getYear());

      var hasEvent = true;

      if (doorData.EVENT_IMAGE) {
        var image_path_parts = doorData.EVENT_IMAGE.split('.');

        image_path_parts[0] += '_lrg';
        doorData.EVENT_LARGE_IMAGE = image_path_parts.join('.');
      }
    }

    generic.template.get({
      path: '/templates/locator/door_row.tmpl',
      object: doorData,
      callback: function (html) {
        var idx = doorData.index_number;
        var node = $(html);

        if (doorData.COUNTRY != site.locator.defaultCountry) {
          node.find('.directions').hide();
        }
        tbody.append(node);
        var row = tbody.find('.door_row_' + idx);

        site.locator.nodes.doorRows.add(row);
        if (hasEvent) {
          site.locator.nodes.doorWithEventRows.add(row);
        } else {
          row.find('.event-details > *').css('display', 'none');
          site.locator.nodes.doorWithoutEventRows.add(row);
        }
        row.bind('click', function () {
          site.locator.ui.launchInfoWindow(idx);
          // $("html, body").animate({ scrollTop: 0 }, "slow");
        });

        if (site.locator.appointmentBooking) {
          var $apptBookLink = node.find('.store-locator__tooltip-book-appointment'),
            abHref = $apptBookLink.attr('href');

          if (doorData.APPT_BOOK_COUNTER_ID) {
            $apptBookLink.attr('href', abHref + '?counter_id=' + doorData.APPT_BOOK_COUNTER_ID);
          } else {
            $apptBookLink.remove();
          }
        }

        var directionsLink = $('a.directions_link').eq(idx);

        directionsLink.bind('click', function (evt) {
          evt.preventDefault();
          // offer directions via google page
          // window.open("https://www.google.com/maps/dir//" + doorData.LATITUDE + "," + doorData.LONGITUDE + "/", "_blank");

          // offer directions within store_locator
          // site.locator.ui.displayMap(true, idx);
          // site.locator.ui.launchInfoWindow(idx);

          // site.locator.getDomNodes();
          _initDirectionsForm();
          // site.locator.ui.resetDirections();
          // google.maps.event.trigger(site.locator.mapDir, 'resize');

          generic.template.get({
            path: '/templates/locator/destination_address.tmpl',
            object: doorData,
            callback: function (html) {
              site.locator.nodes.dirDestination.html(html);
            }
          });
          site.locator.nodes.dirDoorInput.val(doorData.DOOR_ID);
          // site.locator.ui.initDirectionsForm(doorData);
          /**/
        });
        if (site.locator.nodes.container.hasClass('js-enable-directions')) {
          site.locator.ui.directionsLink(row, doorData);
        }
      }
    });
  };

  generic.template.get({
    path: '/templates/locator/doors_table.tmpl',
    callback: function (html) {
      site.locator.nodes.storeResults.html(html);
      tbody = site.locator.nodes.storeResults.find('tbody tr td');
      // resultData.results.each( function(doorID, idx) {
      //     buildRow(locations[doorID], idx);
      // });
      if (site.locator.queryArgs.params !== undefined && site.locator.queryArgs.params.length) {
        var totalResults = site.locator.resultData.sortedResults.length,
          params = site.locator.queryArgs.params[0],
          searchCriteria = [],
          paramKeys = ['state', 'city'];

        if (site.locator.addressDisplayData) {
          searchCriteria.push(site.locator.addressDisplayData);
          site.locator.addressDisplayData = null;
        } else if (params['zip'] !== '' && params['zip'] !== undefined) {
          searchCriteria.push(params['zip']);
        } else if (site.locator.queryArgs.addressDisplayData) {
          searchCriteria.push(site.locator.queryArgs.addressDisplayData);
        } else {
          for (var i = 0; i < paramKeys.length; i++) {
            var paramKey = paramKeys[i];

            if (params[paramKey] !== undefined) {
              searchCriteria.push(params[paramKey]);
            }
          }
        }
        var searchQuery = $.trim(searchCriteria.join(' '));
        var $resultCountNode =
            totalResults == 1 ? $('.results-count-singular') : $('.results-count-plural'),
          $otherCountNode =
            totalResults == 1 ? $('.results-count-plural') : $('.results-count-singular'),
          resultCountText =
            totalResults == 1
              ? $('#locator-results-count-singular').text()
              : $('#locator-results-count-plural').text();

        $resultCountNode
          .html(
            resultCountText
              .replace('::count::', '<span class="count">' + totalResults + '</span>')
              .replace('::query::', '<span class="query">' + searchQuery + '</span>')
          )
          .show();
        $otherCountNode.hide();
      }
      var i = 0;

      for (var d in site.locator.resultData.sortedResults) {
        buildRow(site.locator.resultData.sortedResults[d], i);
        i++;
      }
      if (Object.keys(addthisevent).length > 0) {
        addthisevent.refresh();
      }
      omnidata = [searchQuery, totalResults];
      tms_page_data.tms_page_info['STORELOCATOR'] = omnidata;
      jQuery(window).trigger('STORELOCATOR', [omnidata]);
    }
  });

  /*
   * Initializes the Driving Directions form. Populates State menu. On form submit,
   * the starting address values are concatenated and passed to the data query method
   * via the "locator:submitDirectionsQuery" event.
   */
  var _initDirectionsForm = function () {
    site.locator.nodes.dirSubmit.bind('click', function (evt) {
      var args = {
        startAddress: site.locator.nodes.dirAddrInput.val()
      };
      var doorId = site.locator.nodes.dirDoorInput.val();

      args.doorData = site.locator.resultData.results[doorId];
      $(document).trigger('locator.submitDirectionsQuery', [args]);
    });
  };
  var _clearMenu = function (menu) {
    menu[0].innerHTML = '';
    generic.forms.select.addOption({
      menuNode: menu,
      label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.select_text.text(),
      value: ''
    });
  };
};

site.locator.ui.getImageIndex = function (num) {
  var ltr = String.fromCharCode('A'.charCodeAt(0) + num);

  return ltr;
};

/*
 * Convenience funtion that builds the path to custom pointer images.
 * Images should be named map_marker_[capital letter].png and placed in /media/export/images/locator.
 * @returns {string} relative path to image, e.g., /media/export/images/locator/map_marker_B.png
 */
site.locator.ui.getMarkerImagePath = function (num) {
  var ltr = site.locator.ui.getImageIndex(num);

  return (
    generic.env.domain + '/sites/clinique/themes/cl_base/img/locator/map-marker-' + ltr + '.png'
  );
};

// To fetch the search text value based on the CMS update by either city/free text
site.locator.ui.getSearchVal = function () {
  var $ = jQuery;
  var search = '';
  var cityVal = site.locator.nodes.cityMenu.length > 0 ? site.locator.nodes.cityMenu.val() : '';
  var searchTextVal =
    site.locator.nodes.searchInput.length > 0
      ? $.trim(
          site.locator.nodes.searchInput
            .val()
            .replace(site.locator.nodes.searchInput.attr('placeholder'), '')
        )
      : '';

  search = searchTextVal || cityVal;

  return search;
};

/*
 * This function encapsulates the various calls to the Google Maps API that render
 * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
 * adds markers, and sets up the event handler for clicking on the markers.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayMap = function (directions, i) {
  var results = i === 0 || i ? [i] : site.locator.resultData.results;
  var mapNode = directions ? site.locator.nodes.dirMap : site.locator.nodes.map;

  // if there are no results, center the map on the US, display the map, and just return
  if (!results || results.length === 0) {
    var mapOptions = {
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: false,
      navigationControl: true,
      mapTypeControl: false,
      scaleControl: true
    };
    var map = new google.maps.Map(mapNode[0], mapOptions);
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: 'US' }, function (results, status) {
      var ne = results[0].geometry.viewport.getNorthEast();
      var sw = results[0].geometry.viewport.getSouthWest();

      map.fitBounds(results[0].geometry.viewport);
    });
    mapNode.show();

    return;
  }

  // if we're here, there is result data, proceed accordingly
  var zoomLevel = directions ? 15 : 12;
  var mapOptions = {
    zoom: zoomLevel,
    center: new google.maps.LatLng(
      site.locator.resultData.latitude,
      site.locator.resultData.longitude
    ),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: false,
    navigationControl: true,
    mapTypeControl: false,
    scaleControl: true
  };
  var map = new google.maps.Map(mapNode[0], mapOptions);

  if (directions) {
    site.locator.mapDir = map;
  } else {
    site.locator.map = map;
  }

  // site.locator.nodes.landingPanel.hide();
  mapNode.show();

  if (!directions) {
    var idx = 0;

    for (var d in results) {
      if (idx > 20) {
        break;
      }
      //
      // place markers on Google Map
      var location = site.locator.resultData.sortedResults[idx];
      var lat = location.LATITUDE;
      var lng = location.LONGITUDE;
      var latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        index: idx,
        icon: '/media/images/locator/icons/black_' + idx + '.png',
        title: location.DOORNAME
      });

      site.locator.markers[idx] = marker;
      //
      // build info window
      location.idx = idx;
      location.distanceFormatted = parseFloat(location.DISTANCE).toFixed(2);
      location.display_number = idx + 1;
      site.locator.ui.buildLocationHtml({
        locationData: location,
        callback: function (html) {
          site.locator.locationsHtml[idx] = html;
          //
          // display info window on first location
          if (idx === 0) {
            site.locator.ui.launchInfoWindow(idx);
          }
        }
      });

      eval(
        "google.maps.event.addListener( marker, 'click', function(e) { site.locator.ui.launchInfoWindow( " +
          idx +
          ' );});'
      );

      // set map center for first location
      if (idx === 0) {
        map.setCenter(latLng);
      }
      idx++;
    }
  } else {
    var location = site.locator.resultData.sortedResults[i];
    var lat = location.LATITUDE;
    var lng = location.LONGITUDE;
    var latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
    var marker = new google.maps.Marker({
      icon: markerPath,
      map: map,
      position: latLng
    });

    map.setCenter(latLng);
  }
};

/*
 * Displays Info Window for a given marker/door.
 * @param i {Number} index of door/marker for which info window should be displayed
 */
site.locator.ui.launchInfoWindow = function (i) {
  var $ = jQuery;
  var location = site.locator.resultData.sortedResults[i];
  var map = site.locator.map;

  if (!site.locator.infoWindow) {
    // site.locator.infoWindow = new google.maps.InfoWindow({pixelOffset: new google.maps.Size(0, -44)});
    site.locator.infoWindow = new google.maps.InfoWindow();
    // Re-que LaunchInfoWindow Callback to be executed later down the line.
    requestAnimationFrame(site.locator.ui.launchInfoWindow);
    site.locator.ui.launchInfoWindow(i);

    return;
  }
  var infoWindow = site.locator.infoWindow;
  var infoWindowContent = $('<div></div>');

  if (site.locator.nodes.container.hasClass('js-enable-directions')) {
    infoWindowContent.html(site.locator.locationsHtml[i]);
    site.locator.ui.directionsLink(infoWindowContent, location);
  }
  infoWindow.setContent(site.locator.locationsHtml[i]);
  var marker = site.locator.markers[i];

  infoWindow.open(map, marker);
  // highlight selected marker, default all others
  for (var m = 0; m < site.locator.markers.length; m++) {
    var a_marker = site.locator.markers[m];
    var icon_index = m > 19 ? 0 : m + 1;

    a_marker.setIcon(
      a_marker !== marker
        ? '/media/images/locator/icons/black_' + icon_index + '.png'
        : '/media/images/locator/icons/pink_' + icon_index + '.png'
    );
    a_marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 1);
  }
  marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
  // map.setCenter(marker.position);

  // set the "to" address every time a location is highlighted...
  $('#to_address').val(
    location.ADDRESS +
      ' ' +
      location.ADDRESS2 +
      ' ' +
      location.CITY +
      ' ' +
      location.STATE_OR_PROVINCE +
      ' ' +
      location.ZIP_OR_POSTAL +
      ' ' +
      location.COUNTRY
  );

  // clear out any directions layer and results
  site.locator.directionsDisplay =
    site.locator.directionsDisplay === null
      ? new google.maps.DirectionsRenderer()
      : site.locator.directionsDisplay;
  site.locator.directionsDisplay.setMap(null);
  site.locator.nodes.dirResults.empty();
  $('.store-locator__directions-start, .store-locator__directions-end')
    .addClass('hidden')
    .find('.address')
    .html('');

  site.locator.markerCounter++;
};

/*
 * Callback function for "locator:directionsLoaded" event.
 * Hides Directions form and displays Directions results table.
 * Passes directions query response to google.maps.DirectionsRenderer object.
 * @param response {Object} response from Google Maps directions query
 */
site.locator.ui.displayDirections = function (response) {
  var $ = jQuery;
  // console.log(response);
  // site.locator.nodes.dirForm.addClass("hidden");
  // site.locator.nodes.dirResults.removeClass("hidden");
  // miles intead of mi
  // var miles = response.routes[0].legs[0].distance.text;
  // distance = miles.replace('mi','miles');
  // response.routes[0].legs[0].distance.text = distance;

  // response.routes[0].legs[0].start_address = $('<span><div class="store-locator__directions-destination">A</div></span>').append(response.routes[0].legs[0].start_address);
  $('.store-locator__directions-start .address')
    .html(response.routes[0].legs[0].start_address)
    .parent()
    .removeClass('hidden');
  $('.store-locator__directions-end .address')
    .html(response.routes[0].legs[0].end_address)
    .parent()
    .removeClass('hidden');
  site.locator.directionsDisplay.setDirections(response);
  // console.log($('.directions-form__results').html());
  // <div class="store-locator__directions-destination">A</div>
};

site.locator.ui.resetDirections = function () {
  site.locator.nodes.dirForm.removeClass('hidden');
  site.locator.nodes.dirResults.addClass('hidden');
};

// JS snippet to save the store events to calendar
site.locator.ui.saveToCalendar = function () {
  var $ = jQuery;
  var outlook_calendar = $('.store-locator .hidden.outlook_calendar').html();
  var google_calendar = $('.store-locator .hidden.google_calendar').html();
  var yahoo_calendar = $('.store-locator .hidden.yahoo_calendar').html();
  var hotmail_calendar = $('.store-locator .hidden.hotmail_calendar').html();
  var ical_calendar = $('.store-locator .hidden.ical_calendar').html();
  var facebook_event = $('.store-locator .hidden.facebook_event').html();

  if (Object.keys(addthisevent).length > 0) {
    addthisevent.settings({
      license: 'aptrpsjrpzki5qyxvmue',
      mouse: false,
      css: false,
      outlook: {
        show: true,
        text: outlook_calendar
      },
      google: {
        show: true,
        text: google_calendar
      },
      yahoo: {
        show: true,
        text: yahoo_calendar
      },
      hotmail: {
        show: true,
        text: hotmail_calendar
      },
      ical: {
        show: true,
        text: ical_calendar
      },
      facebook: {
        show: true,
        text: facebook_event
      },
      dropdown: { order: 'outlook,google,yahoo,hotmail,ical,facebook' },
      callback: ''
    });
  }
};

jQuery(document).ready(function () {
  site.locator.getDomNodes();
  site.locator.ui.getRBs();
  site.locator.ui.init();
  site.locator.ui.getTemplates();
  site.locator.ui.saveToCalendar();
  applySelectBoxAccessibility();
}); // end dom:loaded

jQuery(document).bind('locator.directionsLoaded', function (e, param) {
  site.locator.ui.displayDirections(param);
});

/*
 * This function handles the query submit event. It parses the data from the event memo
 * and passes it to the fetch method. This method should NOT be called directly by a UI method;
 * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
 * @param {function} args.callback a function that gets called after door data is returned
 * @param {Array} args.params an Array that contains a hash of parameters that get
 * passed to the JSON-RPC method.
 * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
 * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
 * @param {string} args.params[0].zip Postal Code of origin point location
 * @param {string} args.params[0].state State of origin point location
 * @param {string} args.params[0].city City of origin point location
 * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
 * should be passed to return all stores.
 * @example
 * // var queryArgs = {
 * //     params : [{
 * //         fields : "DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY",
 * //         radius : 25,
 * //         zip    : "10014",
 * //         state  : "NY",
 * //         city   : "New York"
 * //     }],
 * //     callback : function() {
 * //          site.locator.ui.displayMap();
 * //          site.locator.ui.displayResultsTable();
 * //      }
 * // };
 */
site.locator.data.submitQuery = function (args) {
  var $ = jQuery;
  var params = args.params;
  var callbackFn = args.callback;
  var zipRegEx = new RegExp(
    /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/
  );

  if (!params[0].latitude && !params[0].longitude) {
    jQuery.each(site.locator.nodes.errors, function () {
      this.addClass('inactive');
    });
    site.locator.nodes.errors.noLocationsFound.removeClass('inactive');

    return;
  }

  site.locator.data.fetch({
    data: params,
    onSuccess: function (resultData, countersData) {
      jQuery.each(site.locator.nodes.errors, function () {
        this.addClass('inactive');
      });
      // if no results were found...
      if (resultData.count == 0) {
        site.locator.nodes.errors.noStoresFound.removeClass('inactive');
      }
      resultData.maxDistance = parseFloat(args.params[0].radius);
      if (isNaN(resultData.maxDistance)) {
        resultData.maxDistance = null;
      }

      if (site.locator.appointmentBooking) {
        for (var i = 0, len = countersData.length; i < len; i += 1) {
          var cData = countersData[i],
            res = resultData.results[cData.store_no];

          if (res) {
            res.APPT_BOOK_COUNTER_ID = cData.id;
          }
        }
      }

      site.locator.data.setData(resultData);
      if (typeof callbackFn === 'function') {
        callbackFn();
      }
      site.applyTabsNavigation();
    },
    onFailure: function (jsonRpcResponse) {
      var errorObjectsArray = jsonRpcResponse.getMessages();

      jQuery.each(site.locator.nodes.errors, function () {
        this.addClass('inactive');
      });
      site.locator.nodes.errors.noStoresFound.removeClass('inactive');
      site.applyTabsNavigation();
      generic.focusErrors($('.js-locator_error_messages'), $('.js-store-locator-hero'));
    }
  });
  // if first time showing results
  site.locator.nodes.static_default_content_area.slideUp('slow');
  site.locator.nodes.results_area.slideDown('slow');
};

jQuery(document).bind('locator.submitSearchQuery', function (evt, param) {
  site.locator.data.submitQuery(param);
});

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.fetch = function (args) {
  var $ = jQuery;
  generic.jsonrpc.fetch({
    method: 'locator.doorsandevents',
    params: args.data,
    onSuccess: function (r) {
      var resultData = r.getValue();

      if (site.locator.appointmentBooking) {
        generic.jsonrpc.fetch({
          method: 'appointmentbooking.getauthtoken',
          onSuccess: function (rpc) {
            var token = rpc.getValue().auth_token;

            $.ajax({
              url: 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
              type: 'GET',
              data: { token: token, lite: 1 },
              success: function (counters) {
                args.onSuccess(resultData, counters);
              },
              error: function () {
                args.onSuccess(resultData, {});
              }
            });
          },
          onError: function (rpc) {
            // console.log("Error getting authorization token");
          }
        });
      } else {
        args.onSuccess(resultData, {});
      }
    },
    onFailure: function (r) {
      args.onFailure(r);
    }
  });
};

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.setData = function (rawResultData) {
  site.locator.resultData = rawResultData;
  var refineStoresByInput = site.locator.nodes.container.hasClass('js-refine-stores');
  var searchVal = site.locator.ui.getSearchVal();
  var doorsData = [];
  var doorsCount = 0;

  if (rawResultData.maxDistance) {
    // max distance exists
    var filteredResults = {};

    for (var d in rawResultData.results) {
      if (rawResultData.results[d].DISTANCE < rawResultData.maxDistance) {
        if (refineStoresByInput && site.locator.nodes.cityMenu.length > 0) {
          if (rawResultData.results[d].CITY === searchVal) {
            filteredResults[d] = rawResultData.results[d];
            doorsData.push(d);
            doorsCount += 1;
          }
        } else {
          filteredResults[d] = rawResultData.results[d];
        }
      }
    }
    if (refineStoresByInput && site.locator.nodes.cityMenu.length > 0) {
      site.locator.resultData.count = doorsCount;
      site.locator.resultData.doors = doorsData;
    }
    site.locator.resultData.results = filteredResults;
  }

  // asc. sort by distance
  var sortedResults = [];
  var r = site.locator.resultData.results;
  var sortedDoorIds = site.locator.resultData.doors || [];

  function sortByDistance(a, b) {
    var aDist = !r[a].DISTANCE || isNaN(r[a].DISTANCE) ? 0 : parseFloat(r[a].DISTANCE);
    var bDist = !r[b].DISTANCE || isNaN(r[b].DISTANCE) ? 0 : parseFloat(r[b].DISTANCE);

    if (aDist > bDist) {
      return 1;
    } else if (aDist < bDist) {
      return 0;
    }

    return 0;
  }

  sortedDoorIds.sort(sortByDistance);

  for (var i = 0, len = sortedDoorIds.length; i < len; i++) {
    sortedResults.push(site.locator.resultData.results[sortedDoorIds[i]]);
  }
  site.locator.resultData.sortedResults = sortedResults;
};

/*
 * This function retrieves Driving Directions data from Google. The data
 * retrieved is then passed as a memo in the event "locator:directionsLoaded."
 */
site.locator.data.getDirections = function (args) {
  var $ = jQuery;
  var directionsService = new google.maps.DirectionsService();

  site.locator.directionsDisplay =
    site.locator.directionsDisplay === null
      ? new google.maps.DirectionsRenderer()
      : site.locator.directionsDisplay;

  site.locator.nodes.dirResults.empty();
  site.locator.directionsDisplay.setMap(null);

  site.locator.directionsDisplay.setMap(site.locator.map);
  site.locator.directionsDisplay.setPanel($('.directions-form__results').get(0));
  site.locator.directionsDisplay.setOptions({
    markerOptions: {
      icon: '/media/images/locator/icons/pink_A.png'
    }
  });

  var start = $('#from_address').val();
  var end = $('#to_address').val(); // args.doorData.ADDRESS + ", " + args.doorData.CITY + " " + args.doorData.ZIP_OR_POSTAL;
  var request = {
    origin: start,
    destination: end,
    travelMode: eval('google.maps.DirectionsTravelMode.' + site.locator.travelMode)
  };

  directionsService.route(request, function (response, status) {
    $('.dirError').remove();
    $('td[jstcache]').attr('tabindex', 0);
    if (status == google.maps.DirectionsStatus.OK) {
      $(document).trigger('locator.directionsLoaded', [response]);
    } else if (status == google.maps.DirectionsStatus.NOT_FOUND) {
      // Couldn't find address, we need to show the user an error message
      $(
        '<ul class="error_messages dirError"><li>' +
          site.locator.nodes.dirInvalidAddress.text() +
          '</li></ul>'
      ).insertAfter('.directions-header');
    } else if (status == google.maps.DirectionsStatus.ZERO_RESULTS) {
      // No route between locations
      $(
        '<ul class="error_messages dirError"><li>' +
          site.locator.nodes.dirNoRoute.text() +
          '</li></ul>'
      ).insertAfter('.directions-header');
    } else {
      // Some other error that prevented us from getting directions.
      $(
        '<ul class="error_messages dirError"><li>' +
          site.locator.nodes.dirUnknownError.text() +
          '</li></ul>'
      ).insertAfter('.directions-header');
    }
  });
};

jQuery(document).bind('locator.submitDirectionsQuery', function (evt, param) {
  site.locator.data.getDirections(param);
});

var doorDetails = function (index) {
  var $ = jQuery;
  $('a.search_button.directions_link').eq(index).click();
};
var doorDetailsDirections = function (index, fromAddress) {
  var $ = jQuery;
  doorDetails(index);
  $('#locator_directions_panel input.address').val(fromAddress);
  $('.directions_submit').click();
};
